import "core-js/modules/es6.regexp.constructor";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";

var _dec, _class;

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { match } from '@rexlabs/whereabouts';
import { autobind } from 'core-decorators';
import { withWhereabouts } from './connectors';
import invariant from 'invariant';
var Match = (_dec = withWhereabouts(), _dec(_class = autobind(_class =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Match, _PureComponent);

  function Match() {
    _classCallCheck(this, Match);

    return _possibleConstructorReturn(this, _getPrototypeOf(Match).apply(this, arguments));
  }

  _createClass(Match, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          location = _this$props.location,
          route = _this$props.route,
          pattern = _this$props.pattern,
          whereabouts = _this$props.whereabouts,
          children = _this$props.children,
          exact = _this$props.exact;
      invariant(route || pattern, 'You have to define either \'route\' or \'pattern\' prop in \'<Match />\'!');
      var matchLocation = location || whereabouts;
      var matched = null;

      if (route) {
        invariant(route.config, 'Invalid \'route\' prop has been passed into \'<Match />\'! No config node found!');
        matched = match(matchLocation, route.config, {
          exact: exact
        });
      } else {
        matched = match(matchLocation, {
          path: pattern
        }, {
          exact: exact
        });
      }

      if (typeof children === 'function') {
        return children(matched);
      } else if (matched) {
        return children;
      } else {
        return null;
      }
    }
  }]);

  return Match;
}(PureComponent)) || _class) || _class);
Match.propTypes = process.env.NODE_ENV !== "production" ? {
  exact: PropTypes.bool,
  route: PropTypes.object,
  // Only to make pattern matching easier, can also be achieved by
  // passing in the pattern as a route!
  pattern: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)]),
  // Optional location, if not defined <Match /> will use current location
  // from whereabouts state instead
  location: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
} : {};
export default Match;